import { useEffect, useState } from 'react';
import { supabase } from '../config/supabase';

export const useContactInfo = () => {
  const [contactInfo, setContactInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        setLoading(true);
        setError(null);

        console.log('🔍 Fetching contact info...');
        const { data, error: fetchError } = await supabase
          .from('contact_info')
          .select('id, email, phone, address_en, address_ar, working_hours_en, working_hours_ar, whatsapp_url, instagram_url, twitter_url, facebook_url')
          .eq('is_active', true)
          .order('updated_at', { ascending: false })
          .limit(1)
          .maybeSingle();

        console.log('📊 Contact info response:', { data, error: fetchError });

        if (fetchError) {
          console.error('❌ Contact info fetch error:', fetchError);
          throw fetchError;
        }

        console.log('✅ Loaded contact info:', data ? 'Found' : 'Not found');
        setContactInfo(data ?? null);
      } catch (err) {
        console.error('❌ Error fetching contact info:', err);
        setError(err.message || 'Failed to load contact info');
        setContactInfo(null);
      } finally {
        setLoading(false);
      }
    };

    fetchContactInfo();
  }, []);

  return { contactInfo, loading, error };
};

